"use strict";
exports.__esModule = true;
exports.EMBED_MANUAL_PAY_FINISH = void 0;
exports.EMBED_MANUAL_PAY_FINISH = {
    BODY: "We've collected your {{paymentType}} of {{amount}} and submitted your rent payment. It might take 24 hours to reflect in your rent portal.",
    CTA: 'Close window',
    HEADER: 'Rent payment started!',
    NOTICE: 'Keep an eye on your email or download the Flex app to stay up-to-date with your status.'
};
